import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseNavigationService {
  abstract navigate(checkForRootPath?: boolean): Observable<void>;
}
